import React from "react";
import { Props } from "./types";
import { ProjectModel } from "./projectModel";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <div className={styles.loader}>
      <div className={styles.models}>
        <div className={styles.model}>
          <ProjectModel />
        </div>
        <div className={styles.model}>
          <ProjectModel />
        </div>
        <div className={styles.model}>
          <ProjectModel />
        </div>
        <div className={styles.model}>
          <ProjectModel />
        </div>
        <div className={styles.model}>
          <ProjectModel />
        </div>
        <div className={styles.model}>
          <ProjectModel />
        </div>
      </div>
    </div>
  );
}

export { Loader };
